/* ============================================================================
   Yuvakart — "My Account" panel (phone-OTP powered)
   Opens from the header profile icon. After OTP verification it shows the
   customer's real data by phone number: name, past orders, synced wishlist.
   Requires: yk-otp.js loaded first (window.YK_OTP) and worker v9.
   API: window.YK_ACCOUNT.open()
   ============================================================================ */
(function () {
  'use strict';
  if (window.YK_ACCOUNT) return;

  var WORKER_URL = 'https://plain-pine-1366.gayatrikartabu.workers.dev';
  var GOLD = '#C49A2A', GOLD2 = '#F0D67A', DARK = '#1A0800', CREAM = '#FBF3E4';
  var LS = 'yk_otp_verified';

  /* ------------------------------------------------------------- helpers -- */
  function auth() {
    try {
      var v = JSON.parse(localStorage.getItem(LS) || 'null');
      if (v && v.phone && v.proof && Number(v.expiresAt) > Date.now()) return v;
      if (v) localStorage.removeItem(LS);
      return null;
    } catch (e) { return null; }
  }
  function logout() { try { localStorage.removeItem(LS); } catch (e) {} }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (m) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function api(path, params) {
    var qs = Object.keys(params).map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(params[k] == null ? '' : params[k]);
    }).join('&');
    return fetch(WORKER_URL + path + '?' + qs, { method: 'GET', cache: 'no-store' })
      .then(function (r) { return r.json().then(function (j) { if (r.status === 401) j.reauth = true; return j; }); });
  }
  function rupee(a) {
    var n = Number(a);
    if (isNaN(n)) return esc(a);
    try { return '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: 0 }); }
    catch (e) { return '₹' + Math.round(n); }
  }
  function dateStr(iso) {
    try { return new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }); }
    catch (e) { return ''; }
  }
  function nice(s) {
    s = String(s || '').replace(/_/g, ' ').toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  /* --------------------------------------------------------------- style -- */
  var css =
    '.ykacc-ov{position:fixed;inset:0;background:rgba(20,10,2,.5);z-index:2147481000;display:none;' +
    '-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px)}' +
    '.ykacc-ov.on{display:block}' +
    '.ykacc{position:fixed;top:0;right:0;height:100%;width:min(430px,100vw);background:' + CREAM + ';' +
    'z-index:2147481001;transform:translateX(105%);transition:transform .28s ease;display:flex;' +
    'flex-direction:column;box-shadow:-12px 0 40px rgba(20,10,2,.35);font-family:inherit}' +
    '.ykacc.on{transform:translateX(0)}' +
    '.ykacc-hd{background:' + DARK + ';color:' + GOLD2 + ';padding:18px 20px 16px;position:relative}' +
    '.ykacc-hd h3{margin:0;font-size:17px;font-weight:700;color:' + GOLD2 + '}' +
    '.ykacc-hd p{margin:4px 0 0;font-size:12px;color:' + GOLD + ';letter-spacing:.04em}' +
    '.ykacc-x{position:absolute;top:12px;right:14px;border:0;background:none;color:#c9b27a;' +
    'font-size:24px;cursor:pointer;line-height:1}' +
    '.ykacc-bd{flex:1;overflow-y:auto;padding:16px 16px 30px}' +
    '.ykacc-sec{margin:0 0 10px;font-size:12px;font-weight:700;letter-spacing:.14em;color:#8a6d2f;' +
    'text-transform:uppercase;display:flex;align-items:center;gap:8px}' +
    '.ykacc-sec:after{content:"";flex:1;height:1px;background:rgba(196,154,42,.35)}' +
    '.ykacc-card{background:#fff;border:1px solid rgba(196,154,42,.4);border-radius:12px;' +
    'padding:12px 14px;margin-bottom:10px}' +
    '.ykacc-card b{color:' + DARK + ';font-size:13.5px}' +
    '.ykacc-row{display:flex;justify-content:space-between;align-items:center;gap:8px}' +
    '.ykacc-meta{font-size:11.5px;color:#7a6a52;margin-top:3px}' +
    '.ykacc-items{font-size:12px;color:#5d4d35;margin-top:6px;line-height:1.5}' +
    '.ykacc-chip{display:inline-block;font-size:10.5px;font-weight:700;padding:3px 9px;' +
    'border-radius:999px;background:#f3e8cd;color:#7a5c14;margin-left:6px;vertical-align:middle}' +
    '.ykacc-chip.ok{background:#e2f2e4;color:#1e6b2d}' +
    '.ykacc-total{font-weight:700;color:' + DARK + ';font-size:14px;white-space:nowrap}' +
    '.ykacc-empty{text-align:center;color:#8a7a5f;font-size:12.5px;padding:18px 8px}' +
    '.ykacc-wl{display:flex;gap:10px;align-items:center}' +
    '.ykacc-wl img{width:54px;height:54px;object-fit:cover;border-radius:9px;border:1px solid #eadfc5}' +
    '.ykacc-wl .t{flex:1;font-size:12.5px;color:' + DARK + ';font-weight:600;line-height:1.35}' +
    '.ykacc-wl .p{font-size:12px;color:#7a5c14;margin-top:2px}' +
    '.ykacc-rm{border:0;background:none;color:#b03a2e;font-size:17px;cursor:pointer;padding:4px}' +
    '.ykacc-btn{display:block;width:100%;margin-top:6px;padding:12px;border:0;border-radius:999px;' +
    'background:linear-gradient(180deg,#f7e7bd,#e8cd8c);color:#2a1f10;font-weight:700;font-size:13.5px;' +
    'cursor:pointer;text-align:center;text-decoration:none;box-sizing:border-box}' +
    '.ykacc-out{display:block;margin:16px auto 0;background:none;border:0;color:#a0522d;font-size:12px;' +
    'text-decoration:underline;cursor:pointer}' +
    '.ykacc-load{text-align:center;padding:40px 10px;color:#8a6d2f;font-size:13px}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* --------------------------------------------------------------- panel -- */
  var ov, panel, bd, hdName, hdPhone;

  function ensure() {
    if (ov) return;
    ov = document.createElement('div');
    ov.className = 'ykacc-ov';
    document.body.appendChild(ov);
    ov.addEventListener('click', close);

    panel = document.createElement('div');
    panel.className = 'ykacc';
    panel.innerHTML =
      '<div class="ykacc-hd"><button class="ykacc-x" aria-label="Close">&times;</button>' +
      '<h3 id="ykacc-name">My Account</h3><p id="ykacc-ph"></p></div>' +
      '<div class="ykacc-bd" id="ykacc-bd"></div>';
    document.body.appendChild(panel);
    bd = panel.querySelector('#ykacc-bd');
    hdName = panel.querySelector('#ykacc-name');
    hdPhone = panel.querySelector('#ykacc-ph');
    panel.querySelector('.ykacc-x').addEventListener('click', close);
  }

  function open() {
    var a = auth();
    if (!a) {
      if (window.YK_OTP) window.YK_OTP.open({ onVerified: function () { setTimeout(open, 350); } });
      return;
    }
    ensure();
    ov.classList.add('on');
    panel.classList.add('on');
    hdPhone.textContent = '+91 ' + a.phone;
    load(a);
  }
  function close() {
    if (ov) ov.classList.remove('on');
    if (panel) panel.classList.remove('on');
  }

  /* ---------------------------------------------------------------- data -- */
  function load(a) {
    bd.innerHTML = '<div class="ykacc-load">Fetching your account…</div>';
    api('/me', { phone: a.phone, proof: a.proof }).then(function (r) {
      if (auth()?.proof !== a.proof) return;
      if (r.reauth) {
        logout(); close();
        if (window.YK_OTP) window.YK_OTP.open({ onVerified: function () { setTimeout(open, 350); } });
        return;
      }
      if (r.error) { bd.innerHTML = '<div class="ykacc-empty">' + esc(r.error) + '</div>'; return; }
      render(a, r);
      syncWishlist(a, r.wishlist || []);
    }).catch(function () {
      bd.innerHTML = '<div class="ykacc-empty">Network error — please try again</div>';
    });
  }

  function render(a, r) {
    var first = (r.name || '').split(' ')[0];
    hdName.textContent = first ? 'Namaste, ' + first + ' 🙏' : 'My Account';

    var h = '<div class="ykacc-sec">Past orders' + (r.ordersCount ? ' (' + r.ordersCount + ')' : '') + '</div>';
    if (!r.orders || !r.orders.length) {
      h += '<div class="ykacc-empty">' + (r.found ? 'No orders on this number yet.' :
        'No account found for this number yet — your first order will create it.') +
        '</div><a class="ykacc-btn" href="/collections/all">Start Shopping</a>';
    } else {
      for (var i = 0; i < r.orders.length; i++) {
        var o = r.orders[i];
        var chip = o.ship && o.ship.toUpperCase() === 'FULFILLED'
          ? '<span class="ykacc-chip ok">Shipped</span>'
          : '<span class="ykacc-chip">' + esc(nice(o.ship || o.pay || 'Processing')) + '</span>';
        var items = '';
        for (var k = 0; k < o.items.length && k < 3; k++) {
          items += (k ? ', ' : '') + esc(o.items[k].t) + (o.items[k].q > 1 ? ' ×' + o.items[k].q : '');
        }
        if (o.items.length > 3) items += ' +' + (o.items.length - 3) + ' more';
        h += '<div class="ykacc-card"><div class="ykacc-row"><span><b>' + esc(o.name) + '</b>' + chip +
          '</span><span class="ykacc-total">' + rupee(o.total) + '</span></div>' +
          '<div class="ykacc-meta">' + dateStr(o.date) + ' · ' + esc(nice(o.pay)) + '</div>' +
          (window.YKDelivery && window.YKDelivery.orderMessage(o) ? '<div class="ykacc-meta">' + esc(window.YKDelivery.orderMessage(o)) + '</div>' : '') +
          (items ? '<div class="ykacc-items">' + items + '</div>' : '') + '</div>';
      }
    }

    h += '<div class="ykacc-sec" style="margin-top:18px">Wishlist</div><div id="ykacc-wl"></div>';
    h += '<button class="ykacc-out" id="ykacc-logout">Log out of this device</button>';
    bd.innerHTML = h;
    bd.querySelector('#ykacc-logout').addEventListener('click', function () { logout(); close(); });
    renderWishlist();
  }

  function renderWishlist() {
    var box = bd && bd.querySelector('#ykacc-wl');
    if (!box) return;
    var list = (window.YKWish && window.YKWish.get()) || [];
    if (!list.length) {
      box.innerHTML = '<div class="ykacc-empty">Nothing saved yet — tap the ❤ on any product.</div>';
      return;
    }
    box.innerHTML = '';
    list.slice(0, 20).forEach(function (handle) {
      var card = document.createElement('div');
      card.className = 'ykacc-card ykacc-wl';
      card.innerHTML = '<div class="t">' + esc(handle.replace(/-/g, ' ')) + '</div>' +
        '<button class="ykacc-rm" aria-label="Remove">&times;</button>';
      box.appendChild(card);
      card.querySelector('.ykacc-rm').addEventListener('click', function () {
        if (window.YKWish) window.YKWish.toggle(handle);
        renderWishlist();
      });
      fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var img = (p.featured_image || (p.images && p.images[0]) || '');
        card.innerHTML = (img ? '<a href="' + esc(p.url) + '"><img src="' + esc(img) + '" alt=""></a>' : '') +
          '<div class="t"><a href="' + esc(p.url) + '" style="color:inherit;text-decoration:none">' + esc(p.title) + '</a>' +
          '<div class="p">' + rupee(p.price / 100) + '</div></div>' +
          '<button class="ykacc-rm" aria-label="Remove">&times;</button>';
        card.querySelector('.ykacc-rm').addEventListener('click', function () {
          if (window.YKWish) window.YKWish.toggle(handle);
          renderWishlist();
        });
      }).catch(function () {});
    });
  }

  /* ------------------------------------------------- wishlist phone sync -- */
  var pushT = null;
  function pushWishlist(mode) {
    var a = auth();
    if (!a || !window.YKWish) return;
    clearTimeout(pushT);
    pushT = setTimeout(function () {
      api('/wishlist-sync', { phone: a.phone, proof: a.proof, list: window.YKWish.get().join(','), mode: mode || 'replace' })
        .catch(function () {});
    }, 700);
  }
  function syncWishlist(a, serverList) {
    try {
      var local = (window.YKWish && window.YKWish.get()) || [];
      var merged = local.slice();
      var removed = (window.YKWish && window.YKWish.removed && window.YKWish.removed()) || [];
      for (var i = 0; i < serverList.length; i++) {
        if (removed.indexOf(serverList[i]) === -1 && merged.indexOf(serverList[i]) === -1) merged.push(serverList[i]);
      }
      localStorage.setItem('yk_wishlist', JSON.stringify(merged));
      if (removed.length || merged.length !== serverList.length) pushWishlist('replace');
      renderWishlist();
    } catch (e) {}
  }
  window.addEventListener('yk:wishlist-removed', function () {
    var current = auth();
    if (!current || !window.YKWish) return;
    api('/wishlist-sync', { phone: current.phone, proof: current.proof, list: window.YKWish.get().join(','), mode: 'replace' }).catch(function () {});
  });
  /* keep server copy fresh whenever a verified user taps any heart */
  (function wrapToggle() {
    function tryWrap() {
      if (!window.YKWish || window.YKWish.__ykWrapped) return !!window.YKWish;
      var orig = window.YKWish.toggle;
      window.YKWish.toggle = function (h) {
        var r = orig(h);
        if (auth()) pushWishlist('replace');
        return r;
      };
      window.YKWish.__ykWrapped = true;
      return true;
    }
    if (!tryWrap()) {
      document.addEventListener('DOMContentLoaded', tryWrap);
      setTimeout(tryWrap, 1200);
    }
  })();

  /* ------------------------------------------ header profile icon hook --- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('account') === -1) return;
    var inHeader = a.closest('.yk-actions, .header__icons, .header-actions, header');
    if (!inHeader) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);

  window.YK_ACCOUNT = { open: open, close: close };

  /* test hook: ?ykacct=1 auto-opens the account panel */
  if (/[?&]ykacct=1/.test(location.search)) {
    var boot = function () { setTimeout(open, 700); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})();

